// extracted by mini-css-extract-plugin
export default {"control":"Control_control__vFlGQ","content":"Control_content__x5tYQ","input":"Control_input__y-gFi","labelContainer":"Control_labelContainer__7j69O"};